// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from '../component';

/**
 * @class Jsw.form.Form
 * @extends Jsw.Component
 */
export const Form = Class.create(Component, {
    _tag: 'form',

    _initConfiguration($super, config) {
        config = config || {};
        config.attrs = Object.extend({
            enctype: 'application/x-www-form-urlencoded',
            method: 'post',
        }, config.attrs || {});

        $super(config);
    },

    render($super) {
        $super();

        const params = this._getConfigParam('params', {});
        if ($('forgery_protection_token')) {
            params.forgery_protection_token = $('forgery_protection_token').content; // eslint-disable-line camelcase
        }

        Object.keys(params).forEach(function (name) {
            this._componentElement.insert(new Element('input', {
                type: 'hidden',
                name,
                value: params[name],
            }));
        }.bind(this));
    },

    _addEvents() {
        this._componentElement._formSubmit = this._componentElement.submit;
        this._componentElement.submit = this._onSubmit.bind(this);
        this._componentElement.observe('submit', function (event) {
            this._onSubmit();
            event.stop();
        }.bind(this));
    },

    _onSubmit() {
        this._componentElement._formSubmit();
    },
});



// WEBPACK FOOTER //
// ./jsw/form/form.js